import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/dist/css/splide.min.css";
import React, { Fragment } from "react";
import { ArrowRight } from "react-feather";
import { Link } from "react-router-dom";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  CardFooter,
  UncontrolledAccordion,
} from "reactstrap";
import "./CustomAvatartGroup.css";
import { roleUser } from "../utils/utils";

const SliderWorkChat = (props) => {
  const { data, describe } = props;
  const role = roleUser();
  return (
    <div className="custom-splide">
      <UncontrolledAccordion className="accordion-border mb-1" defaultOpen="1">
        <AccordionItem>
          <AccordionHeader targetId="1" style={{ background: "#DFF2F8" }}>
            {describe}
          </AccordionHeader>
          {role !== "client" ? (
            <AccordionBody accordionId="1">
              <div>
                <Splide
                  options={{
                    perPage: 3,
                    rewind: true,
                  }}
                  aria-label="React Splide Example"
                >
                  {data?.map((item, index) => {
                    return (
                      <Fragment key={index}>
                        <SplideSlide className="me-1">
                          <Card
                            style={{
                              minHeight: "200px",
                              border: "1px solid rgb(156 232 250)",
                            }}
                          >
                            <CardBody>
                              <div>
                                <h4>{item?.title}</h4>
                              </div>
                              <div>{item?.content}</div>
                            </CardBody>
                            <CardFooter
                              style={{
                                background: "#DFF2F8",
                                borderTop: "1px solid rgb(156 232 250)",
                              }}
                            >
                              <a href={item?.link} target="_blank">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div
                                    style={{
                                      textTransform: "capitalize",
                                      color: "rgb(5 154 189)",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {item?.nameButton}
                                  </div>
                                  <div
                                    style={{
                                      border: "1px solid #00BBE6",
                                      borderRadius: "50%",
                                      color: "#00BBE6",
                                    }}
                                  >
                                    <ArrowRight size={18} />
                                  </div>
                                </div>
                              </a>
                            </CardFooter>
                          </Card>
                        </SplideSlide>
                      </Fragment>
                    );
                  })}
                </Splide>
              </div>
            </AccordionBody>
          ) : (
            ""
          )}
        </AccordionItem>
      </UncontrolledAccordion>
    </div>
  );
};

export default SliderWorkChat;
